import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Image, Container } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";
import '../../../../../Assets/css/review.css'
import  arrowleft from '../assets/images/arrow-left-green.png'
import  arrowright from '../assets/images/arrow-right-green.png'
import  google from '../assets/images/google.webp'
import  yelp from '../assets/images/yelp.webp'
import  khanlogo from '../assets/images/khan-logo-black.png'

const Customer = () => {
  const [customerData, setCustomerData] = useState([]);

  const GetCustomerRewies = useCallback(() => {
    axios
      .get(`${base_url}/common/site_reviews`, { headers: postHeader })
      .then(({ data }) => {
        if (data.status === 1) {
          setCustomerData(data.data);
        }
      })
      .catch((error) => console.error("Error fetching reviews:", error));
  }, []);

  useEffect(() => {
    GetCustomerRewies();
  }, [GetCustomerRewies]);

  useEffect(() => {
      const updateTabIndex = () => {
        document.querySelectorAll(".slick-slide[aria-hidden='true']").forEach((slide) => {
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", "-1");
          });
        });
    
        document.querySelectorAll(".slick-slide[aria-hidden='false']").forEach((slide) => {
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", "0");
          });
        });
      };
    
      // Run on mount
      updateTabIndex();
    
      // Re-run after a short delay in case of dynamic content
      setTimeout(updateTabIndex, 500);
    }, []);

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <Image src={arrowleft} alt="left arrow" />,
    nextArrow: <Image src={arrowright} alt=" Rigth arrow" />,
    responsive: [
      { breakpoint: 1479, settings: { slidesToShow: 1, dots: false,} },
      { breakpoint: 1025, settings: { slidesToShow: 1, dots: false,} },
      { breakpoint: 600, settings: { slidesToShow: 1, dots: false,} },
    ],
    beforeChange: () => {
      setTimeout(() => {
        const slides = document.querySelectorAll(".slick-slide");
        slides.forEach((slide) => {
          const isHidden = slide.getAttribute("aria-hidden") === "true";
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", isHidden ? "-1" : "0");
          });
        });
      }, 100); // You can increase this to 300–500ms if needed
    }
  };

  const customerDataGoogle = [
    {
      username:"Aramis A",
      review:"From start to finish, our experience customizing our rings with Khan Diamonds was nothing short of amazing. They took the time to truly understand our vision, guiding us through every step of the design process with patience, expertise, and ",
    },
    {
      username:"Doan N",
      review:"I had a great experience with Khan Diamonds. I contacted Iqbal after months of looking for the upgraded engagement ring.",
    },
    {
      username:"Cassy Lee",
      review:"Iqbal and family were efficient, kind, sharp eyed, and knew exactly what I wanted probably within 15mins in his store. I didn’t really know what I wanted as my wedding band prior to coming in, but I did have a requirement that it should ",
    },
    {
      username:"Katharine Dix",
      review:"The Khan family were incredibly informed, honest, and helpful! They took their time and had a wealth of knowledge. I would recommend to all friends and family. They had a great selection of women’s and men’s rings to try on, as well as ",
    },
    
    
      ]
  const customerDataYelp = [
{
  username:"Sarah R.",
  review:"This is an overdue review for Iqbal and his family at Khan diamonds! I found Khan Diamonds through Yelp and it was incredibly easy for me to make an appointment for after work. ",
},
{
  username:"Sarah B.",
  review:"My fiancé and I proposed to each other, and each purchased the ring from Khan's! Could not be happier with them (and the whole experience). The rings have held up well months down the line.",
},
{
  username:"Rachel R.",
  review:"My fiancé and I had the most wonderful experience here! We stumbled upon this jeweler looking for wedding bands. Iqbal was the most helpful, kind, and knowledgeable jeweler.",
},
{
  username:"Hannah L.",
  review:"BEST. EVER. I have never written a review before but I was so blown away by Iqbal. I hadn't gotten my rings professionally cleaned since I got them (7 years ago, oops.) and they came out looking absolutely brand new!!! He also did an incredible job at resizing them and was able to do 2 rings and have them back to me in a day.",
}

  ]

  const customerDataKhanWebSite = [
    {
      username:"Momo",
      review:"I rarely write reviews, and I am writing this review 2 years after buying my fiancé's wedding ring from Khan Diamonds. This guy is the best!!!!! Disclaimer: I don't know anything about jewelry, and m ",
    },
    {
      username:"Matthew Lapinski",
      review:"First off, Iqbal is the epitome of a businessman. His reputation is everything and he will tell you how it is (his experience really shines through the entire process). I had a family diamond generous ",
    },
    {
      username:"Annie Poirier",
      review:"Before he retired several years ago, my father was a fine jeweler for more than 40 years, owning more than 15 distinct stores across Boston and the greater Boston area. When it came time to make my en ",
    },
    {
      username:"Aimee Edmondo",
      review:"I discovered Khan Diamonds through all of the wonderful Google reviews I read about Iqbal. Iqbal worked with my fiancé and I to repurpose some old family jewelry to create a custom engagement ring us ",
    }
    
      ]

  return (
    <section className="rcs_customer_say_section">
      <Container fluid className="showcase-container">
        <div className="d-flex align-items-center justify-content-center pb-3">
          <Heading className="text-sm-center text-center p-0">
            <h2>Our Customer Feedback</h2>
            <p className="mb-4">Don’t take our word for it. Trust our customers</p>
          </Heading>
        </div>

        <Row>
          <Col sm={12} md={4} lg={4}>
              <div className="kh_Review_slider_outer_box">
              <div class="title-box2 text-center">
                <div class="goog_reviews">
                  <a href="https://www.google.com/search?q=khan+diamonds&sca_esv=afb5579b9aac608a&ei=16LiZ7vfIt3G4-EP37zA6QQ&gs_ssp=eJzj4tVP1zc0TCozTM4pyMg1YLRSNaiwsEw1NjewMDZPTTRJNbMwtTKoSDFKS0w0NkkxNEuzsDA2NPDizc5IzFNIyUzMzc9LKQYAq3cUTA&oq=khandiamonds&gs_lp=Egxnd3Mtd2l6LXNlcnAiDGtoYW5kaWFtb25kcyoCCAAyEBAuGIAEGLADGMcBGA0YrwEyChAAGIAEGLADGA0yCRAAGLADGA0YHjIJEAAYsAMYDRgeMg4QABiABBiwAxiGAxiKBTIOEAAYgAQYsAMYhgMYigUyDhAAGIAEGLADGIYDGIoFMg4QABiABBiwAxiGAxiKBTIOEAAYgAQYsAMYhgMYigUyCxAAGIAEGLADGKIESOYdUABYAHABeACQAQCYAQCgAQCqAQC4AQHIAQCYAgGgAgeYAwCIBgGQBgqSBwExoAcAsgcAuAcA&sclient=gws-wiz-serp#lrd=0x89e370837ea4e685:0xd2faa34d16f88310,1,,,,"><img src={google} alt="Customer Feedback"/></a>
                </div>
              </div>
            
         
                <div>
                  <Slider className="rcs_customer_say_inner" {...settings2}>
                    {customerDataGoogle.map((customdata, index) => (
                      <div className="rcs_customer_review_slide_item" key={index}>
                          <div className="rcs_customer_review_slide_title text-center">
                            <h3>{customdata?.username}</h3>
                            <Rating name="half-rating-read" value={5} precision={0.5} size="medium" readOnly />
                        </div>
                        <div className="rcs_customer_slide_text_content mb-4">
                          <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                          <Link to="#" onClick={() => window.open('https://www.google.com/search?q=khan+diamonds&sca_esv=afb5579b9aac608a&ei=16LiZ7vfIt3G4-EP37zA6QQ&gs_ssp=eJzj4tVP1zc0TCozTM4pyMg1YLRSNaiwsEw1NjewMDZPTTRJNbMwtTKoSDFKS0w0NkkxNEuzsDA2NPDizc5IzFNIyUzMzc9LKQYAq3cUTA&oq=khandiamonds&gs_lp=Egxnd3Mtd2l6LXNlcnAiDGtoYW5kaWFtb25kcyoCCAAyEBAuGIAEGLADGMcBGA0YrwEyChAAGIAEGLADGA0yCRAAGLADGA0YHjIJEAAYsAMYDRgeMg4QABiABBiwAxiGAxiKBTIOEAAYgAQYsAMYhgMYigUyDhAAGIAEGLADGIYDGIoFMg4QABiABBiwAxiGAxiKBTIOEAAYgAQYsAMYhgMYigUyCxAAGIAEGLADGKIESOYdUABYAHABeACQAQCYAQCgAQCqAQC4AQHIAQCYAgGgAgeYAwCIBgGQBgqSBwExoAcAsgcAuAcA&sclient=gws-wiz-serp#lrd=0x89e370837ea4e685:0xd2faa34d16f88310,1,,,,', "_blank")}>
                            Read More...
                          </Link>
                        </div>
                     
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
          </Col>
          <Col sm={12} md={4} lg={4}>
              <div className="kh_Review_slider_outer_box">
              <div class="title-box2 text-center">
                <div class="goog_reviews">
                  <a href="/"><img src={khanlogo} alt="Customer Feedback" /></a>
                </div>
              </div>
            
         
                <div>
                  <Slider className="rcs_customer_say_inner" {...settings2}>
                    {customerDataKhanWebSite.map((customdata, index) => (
                      <div className="rcs_customer_review_slide_item" key={index}>
                          <div className="rcs_customer_review_slide_title text-center">
                            <h3>{customdata?.username}</h3>
                            <Rating name="half-rating-read" value={ 5} precision={0.5} size="medium" readOnly />
                        </div>
                        <div className="rcs_customer_slide_text_content mb-4">
                          <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                          <Link to="#" onClick={() => window.open("#", "_blank")}>
                            Read More...
                          </Link>
                        </div>
                     
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
          </Col>
          <Col sm={12} md={4} lg={4}>
              <div className="kh_Review_slider_outer_box">
              <div class="title-box2 text-center">
                <div class="goog_reviews">
                  <a href="https://www.yelp.com/biz/khan-diamonds-boston-5" target="_blank" rel="noreferrer"><img src={yelp} alt="Customer Feedback"/></a>
                </div>
              </div>
            
         
                <div>
                  <Slider className="rcs_customer_say_inner" {...settings2}>
                    {customerDataYelp.map((customdata, index) => (
                      <div className="rcs_customer_review_slide_item" key={index}>
                          <div className="rcs_customer_review_slide_title text-center">
                            <h3>{customdata?.username}</h3>
                            <Rating name="half-rating-read" value={ 5} precision={0.5} size="medium" readOnly />
                        </div>
                        <div className="rcs_customer_slide_text_content mb-4">
                          <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                          <Link to="#" onClick={() => window.open('https://www.yelp.com/biz/khan-diamonds-boston-5', "_blank")}>
                            Read More...
                          </Link>
                        </div>
                     
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
          </Col>
        </Row>

     
      </Container>
    </section>
  );
};

export default Customer;
